const tipoCalculoSugestaoDoencasGravesList = [
    {
        id: 'D', //  HARDCODE.idTipoCalculoSugestaoDoencasGravesDespesa
        descricao: 'Múltiplo da Despesa',
        ordem: 10,
    },
    {
        id: 'R', //  HARDCODE.idTipoCalculoSugestaoDoencasGravesReceita
        descricao: 'Múltiplo da Receita',
        ordem: 20,
    },
]

export default tipoCalculoSugestaoDoencasGravesList